import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectSwitchingTo } from "../../features/contexts/contexts-slice";
import { switchPortalContext } from "../../features/contexts/slice-extensions/contexts-slice-extension";
import { PORTAL_MEMBER_PARAM } from "../../features/portal/hooks/usePortalMember";
import { selectPortalMe, selectPortalSession } from "../../features/portal/portal-slice";
import { findContextOffer } from "../../features/portal/utils/findContextOffer";

/**
 * A portal deep link for another row of the signed-in email (another school): instead of the page,
 * one line naming the school and the switch, which continues to the same URL.
 */
const PortalContextOffer = ({ children }: { children: ReactNode }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [params] = useSearchParams();
  const me = useAppSelector(selectPortalMe);
  const session = useAppSelector(selectPortalSession);
  const switchingTo = useAppSelector(selectSwitchingTo);
  const offer = findContextOffer(me, params.get(PORTAL_MEMBER_PARAM), session?.contexts ?? []);
  if (!offer) return <>{children}</>;

  const continueTo = `${location.pathname}${location.search}`;
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-8">
      <p className="text-grey-20 dark:text-white">
        {t("contexts.deepLink", { organization: offer.organizationName })}
      </p>
      <button
        type="button"
        className="btn btn-primary mt-4"
        disabled={switchingTo !== null}
        onClick={() => dispatch(switchPortalContext({ memberId: offer.memberId, continueTo }))}
      >
        {t("contexts.switch")}
      </button>
    </section>
  );
};

export default PortalContextOffer;
